import {i18n} from 'common'
import CustomPeriodForm from 'components/Display/Dashboard/CustomPeriodForm'
import Dialog from 'components/Display/Dialog/Dialog'
import {yupResolver} from '@hookform/resolvers/yup'
import {periodSchema} from 'services/utils/validationsSchemas'
import {useForm} from 'react-hook-form'
import moment from 'moment'

const PeriodSelectDialog = ({open, onSelectPeriod, onCancel}) => {
    const {
        control: formControl,
        formState: {errors: formErrors, isValid},
        handleSubmit,
        // watch,
        reset,
    } = useForm({
        mode: 'all',
        resolver: yupResolver(periodSchema),
    })

    const submit = handleSubmit((data) =>
        onSelectPeriod({from: moment(data.from), to: moment(data.to)})
    )

    const onCancelSelection = () => {
        reset()
        onCancel()
    }

    return (
        <Dialog
            title={i18n.t('dashboard.periodSelectTitle')}
            open={open}
            handleClose={onCancelSelection}
            handleSave={submit}
            onCancel={onCancelSelection}
            isValid={isValid}>
            <CustomPeriodForm
                formControl={formControl}
                formErrors={formErrors}
            />
        </Dialog>
    )
}

export default PeriodSelectDialog
